<ds-view-tracker [object]="(itemRD$ | async)?.payload"></ds-view-tracker>
<ds-loading *ngIf="(itemRD$ | async)?.isLoading" message="{{'loading.item' | translate}}"></ds-loading>
<ds-cris-layout [item]="(itemRD$ | async)?.payload"></ds-cris-layout>
